/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ExportacaoFontesNaoSeladasAutorizacaoFormDto } from '../models/exportacao-fontes-nao-seladas-autorizacao-form-dto';
import { ExportacaoFontesNaoSeladasCriteriaDto } from '../models/exportacao-fontes-nao-seladas-criteria-dto';
import { ExportacaoFontesNaoSeladasDto } from '../models/exportacao-fontes-nao-seladas-dto';
import { ExportacaoFontesNaoSeladasFormDto } from '../models/exportacao-fontes-nao-seladas-form-dto';
import { ExportacaoFontesNaoSeladasPageDto } from '../models/exportacao-fontes-nao-seladas-page-dto';


/**
 * Transferência/Exportação de Fontes Não Seladas
 */
@Injectable({
  providedIn: 'root',
})
export class ExportacaoFontesNaoSeladasService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getExportacoesFns
   */
  static readonly GetExportacoesFnsPath = '/exportacao-fontes-nao-seladas';

  /**
   * Pesquisar exportações - fontes não seladas.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getExportacoesFns()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExportacoesFns$Response(params?: {
    criteria?: ExportacaoFontesNaoSeladasCriteriaDto;
  }): Observable<StrictHttpResponse<ExportacaoFontesNaoSeladasPageDto>> {

    const rb = new RequestBuilder(this.rootUrl, ExportacaoFontesNaoSeladasService.GetExportacoesFnsPath, 'get');
    if (params) {
      rb.query('criteria', params.criteria, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ExportacaoFontesNaoSeladasPageDto>;
      })
    );
  }

  /**
   * Pesquisar exportações - fontes não seladas.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getExportacoesFns$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExportacoesFns(params?: {
    criteria?: ExportacaoFontesNaoSeladasCriteriaDto;
  }): Observable<ExportacaoFontesNaoSeladasPageDto> {

    return this.getExportacoesFns$Response(params).pipe(
      map((r: StrictHttpResponse<ExportacaoFontesNaoSeladasPageDto>) => r.body as ExportacaoFontesNaoSeladasPageDto)
    );
  }

  /**
   * Path part for operation createExportacaoFns
   */
  static readonly CreateExportacaoFnsPath = '/exportacao-fontes-nao-seladas';

  /**
   * Submeter pedido de exportação de fontes não seladas.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createExportacaoFns()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createExportacaoFns$Response(params?: {
    body?: ExportacaoFontesNaoSeladasFormDto
  }): Observable<StrictHttpResponse<ExportacaoFontesNaoSeladasDto>> {

    const rb = new RequestBuilder(this.rootUrl, ExportacaoFontesNaoSeladasService.CreateExportacaoFnsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ExportacaoFontesNaoSeladasDto>;
      })
    );
  }

  /**
   * Submeter pedido de exportação de fontes não seladas.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createExportacaoFns$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createExportacaoFns(params?: {
    body?: ExportacaoFontesNaoSeladasFormDto
  }): Observable<ExportacaoFontesNaoSeladasDto> {

    return this.createExportacaoFns$Response(params).pipe(
      map((r: StrictHttpResponse<ExportacaoFontesNaoSeladasDto>) => r.body as ExportacaoFontesNaoSeladasDto)
    );
  }

  /**
   * Path part for operation getExportacaoFns
   */
  static readonly GetExportacaoFnsPath = '/exportacao-fontes-nao-seladas/{id}';

  /**
   * Obter exportação de Fontes Não Seladas.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getExportacaoFns()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExportacaoFns$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<ExportacaoFontesNaoSeladasDto>> {

    const rb = new RequestBuilder(this.rootUrl, ExportacaoFontesNaoSeladasService.GetExportacaoFnsPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ExportacaoFontesNaoSeladasDto>;
      })
    );
  }

  /**
   * Obter exportação de Fontes Não Seladas.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getExportacaoFns$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExportacaoFns(params: {
    id: number;
  }): Observable<ExportacaoFontesNaoSeladasDto> {

    return this.getExportacaoFns$Response(params).pipe(
      map((r: StrictHttpResponse<ExportacaoFontesNaoSeladasDto>) => r.body as ExportacaoFontesNaoSeladasDto)
    );
  }

  /**
   * Path part for operation updateExportacaoFns
   */
  static readonly UpdateExportacaoFnsPath = '/exportacao-fontes-nao-seladas/{id}';

  /**
   * Editar Pedido de Enquadramento Exportação Fontes NãoSeladas.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateExportacaoFns()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateExportacaoFns$Response(params: {
    id: number;
    body?: ExportacaoFontesNaoSeladasFormDto
  }): Observable<StrictHttpResponse<ExportacaoFontesNaoSeladasDto>> {

    const rb = new RequestBuilder(this.rootUrl, ExportacaoFontesNaoSeladasService.UpdateExportacaoFnsPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ExportacaoFontesNaoSeladasDto>;
      })
    );
  }

  /**
   * Editar Pedido de Enquadramento Exportação Fontes NãoSeladas.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateExportacaoFns$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateExportacaoFns(params: {
    id: number;
    body?: ExportacaoFontesNaoSeladasFormDto
  }): Observable<ExportacaoFontesNaoSeladasDto> {

    return this.updateExportacaoFns$Response(params).pipe(
      map((r: StrictHttpResponse<ExportacaoFontesNaoSeladasDto>) => r.body as ExportacaoFontesNaoSeladasDto)
    );
  }

  /**
   * Path part for operation updateAutorizacaoExportacaoFns
   */
  static readonly UpdateAutorizacaoExportacaoFnsPath = '/exportacao-fontes-nao-seladas/{id}/autorizacao';

  /**
   * Preencher autorização de um pedido de exportação de fontes não seladas.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAutorizacaoExportacaoFns()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAutorizacaoExportacaoFns$Response(params: {
    id: number;
    body?: ExportacaoFontesNaoSeladasAutorizacaoFormDto
  }): Observable<StrictHttpResponse<ExportacaoFontesNaoSeladasDto>> {

    const rb = new RequestBuilder(this.rootUrl, ExportacaoFontesNaoSeladasService.UpdateAutorizacaoExportacaoFnsPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ExportacaoFontesNaoSeladasDto>;
      })
    );
  }

  /**
   * Preencher autorização de um pedido de exportação de fontes não seladas.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateAutorizacaoExportacaoFns$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAutorizacaoExportacaoFns(params: {
    id: number;
    body?: ExportacaoFontesNaoSeladasAutorizacaoFormDto
  }): Observable<ExportacaoFontesNaoSeladasDto> {

    return this.updateAutorizacaoExportacaoFns$Response(params).pipe(
      map((r: StrictHttpResponse<ExportacaoFontesNaoSeladasDto>) => r.body as ExportacaoFontesNaoSeladasDto)
    );
  }

  /**
   * Path part for operation previewDocAutorizacaoExportacaoFns
   */
  static readonly PreviewDocAutorizacaoExportacaoFnsPath = '/exportacao-fontes-nao-seladas/{id}/preview-doc-autorizacao';

  /**
   * Preview Documento de Autorização.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `previewDocAutorizacaoExportacaoFns()` instead.
   *
   * This method doesn't expect any request body.
   */
  previewDocAutorizacaoExportacaoFns$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, ExportacaoFontesNaoSeladasService.PreviewDocAutorizacaoExportacaoFnsPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/pdf'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Preview Documento de Autorização.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `previewDocAutorizacaoExportacaoFns$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  previewDocAutorizacaoExportacaoFns(params: {
    id: number;
  }): Observable<Blob> {

    return this.previewDocAutorizacaoExportacaoFns$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

}
